/* eslint-disable */
import React from 'react';
import moment from 'moment';

import SelectDropdown from '../../components/SelectDropdown';
import ContentHeader from '../../containers/ContentHeader';
import { EkgTable } from '../../containers/Tables';
import PageTab from '../../components/PageTab';
import PageTabs from '../../components/PageTabs';
import { getEkgResultOptions } from '../../constants/recordingMaps';
import { getName, getPhysicianName } from '../../containers/Utilities';
import PrevIcon from 'static/images/icons/chevron-left.svg';
import NextIcon from 'static/images/icons/chevron-right.svg';
import {
  ROUTES,
  CONFIRMED,
  CONFIRMED_OPTION,
  TRIAGE,
  TRIAGE_OPTION,
  KPSP_PRACTICE_INBOX,
  PHYSICIAN,
  ALL_PATIENTS_OPTION,
  DASHBOARD_SIDEBAR_WIDTH,
  HEADER_HEIGHT,
  MIN_BPM_VALUE,
  MAX_BPM_VALUE,
  MIN_QTCF_VALUE,
  MAX_QTCF_VALUE,
  KARDIA_PRO_START_DATE,
  KARDIA_PRO_END_DATE,
  EKG_REVIEW_PAGE_TABS,
  CONTENT_WIDTH,
  EKG_TABLE_ROW_HEIGHT,
  DATE_OMIT_DAY_FMT,
} from '../../constants';
import styles from './QtEkgReview.css';
import {
  needToBustCache,
  filterIsPhysicianPermission,
} from '../../store/appReducer';
import SearchResultsLabel from '../../components/Search/SearchResultsLabel';
import {
  checkRpmFeatureEnabled,
  checkServiceProviderFeatureEnabled,
} from 'configs';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';

class QtEkgReview extends React.Component {
  state = {
    innerHeight: 0,
    innerWidth: 0,
  };

  UNSAFE_componentWillMount() {
    const { dataLastUpdated, getEkgReviewData } = this.props;

    getEkgReviewData(needToBustCache(dataLastUpdated));

    window.addEventListener('resize', this.handleResize);
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  beginningDate = KARDIA_PRO_START_DATE;
  today = KARDIA_PRO_END_DATE;

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    });
  };

  handleOnInboxClick = () => {
    this.props.handleOnFilterButtonClick(null);
  };

  handleOnTriageEKGNextClick = () => {
    this.props.handleOnEKGNextClick();
  };

  filterPhysicianFromRecordings = recordings => {
    const options = [];
    recordings.forEach(r => {
      const patient = r.participantProfile;
      if (patient && patient.orderingPhysician) {
        const physician = patient.orderingPhysician;
        const opt = {
          id: physician.id,
          label: getName(physician.firstName, physician.lastName, ''),
        };

        if (!options.some(e => e.id === opt.id)) {
          options.push(opt);
        }
      }
    });
    return options;
  };

  filterPracticeFromRecordings = recordings => {
    const options = [];
    recordings.forEach(r => {
      const practice = r.orderingPractice;
      if (practice) {
        const opt = {
          id: practice.id,
          label: practice.name,
        };

        if (!options.some(e => e.id === opt.id)) {
          options.push(opt);
        }
      }
    });
    return options;
  };

  onEkgTableRowClick = ({ index, rowData }) => {
    this.props.handleOnRowClick({ index, rowData });
  };

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      handleOnRefreshClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      bulkActionSuccessMessage,
      selectedIndex,
      selectedPageTab,
      selectedInboxId,
      selectedEkgResult,
      selectedPatientId,
      selectedPhysicianId,
      selectedPhysicians,
      selectedAssignedPhysicians,
      selectedQtOrderingPractice,
      selectedStartDate,
      selectedEndDate,
      selectedPopover,
      selectedBpmStartValue,
      selectedBpmEndValue,
      selectedQtcfStartValue,
      selectedQtcfEndValue,
      selectedIntrText,
      selectedPatientText,
      selectedConfirmedCurrentMonth,
      selectedEkgs,
      me,
      ekgs,
      ekgStacks,
      ekgStackCounts,
      patients,
      physicians,
      orderingPactices,
      recordingIds,
      sortBy,
      sortDirection,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnTabClick,
      handleOnPhysicianInboxChange,
      handleOnProviderInboxChange,
      handleOnRowClick,
      handleOnBulkAction,
      handleOnBulkActionTriggerModal,
      handleOnBulkActionCloseModal,
      handleOnSelectionClick,
      handleOnConfirmedMonthClick,
      stackNextResultsToken,
    } = this.props;
    const { innerHeight, innerWidth } = this.state;
    let recordings = [];

    let contentHeightRealestate = innerHeight - HEADER_HEIGHT - 11;
    const physicianInboxHeight = 51;
    switch (selectedPageTab) {
      case EKG_REVIEW_PAGE_TABS.PHYSICIAN:
        contentHeightRealestate -= physicianInboxHeight;
        break;
      case EKG_REVIEW_PAGE_TABS.CONFIRMED:
        contentHeightRealestate -= physicianInboxHeight;
        break;
      default:
        break;
    }
    const contentWidthRealestate = CONTENT_WIDTH;

    let dateRange = [this.beginningDate, this.today];

    let triageCount;
    let currentLoggedInPhysicianId;
    let physicianCount;

    let selectedInbox;
    let inboxOptions = [];
    let orderingPacticesOptions = [];
    let physicianOptions = [];
    const noneOptionItem = {
      id: '0',
      label: '<None>',
    };
    // When ever a tab is switched, this switch case decides the selected Inbox
    switch (selectedPageTab) {
      case TRIAGE:
        selectedInbox = TRIAGE_OPTION;
        break;
      case PHYSICIAN:
        if (physicians.data) {
          selectedInbox = selectedInboxId && physicians.data.byId[selectedInboxId]
        }
        break;
      case KPSP_PRACTICE_INBOX:
        if(!orderingPactices.data.find(d => d.teamID === selectedInboxId)){
          selectedInbox = {
            id: orderingPactices.data[0].teamID,
            name: orderingPactices.data[0].teamName,
          };
        }
        break;
      case CONFIRMED:
        selectedInbox = CONFIRMED_OPTION;
        dateRange = [
          moment(selectedConfirmedCurrentMonth)
            .startOf('month')
            .toDate(),
          moment(selectedConfirmedCurrentMonth)
            .endOf('month')
            .toDate(),
        ];
        break;
      default:
        break;
    }

    if (physicians.data) {
      inboxOptions = [
        ...inboxOptions,
        ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id]),
      ];
    }
    if (orderingPactices.data){
      orderingPactices.data.map(d =>{
          orderingPacticesOptions.push({
            id: d.teamID,
            name: d.teamName,
          })
      })
    }

    if (ekgs.data && !refreshClicked) {
      recordings = recordingIds.map(id => ekgs.data.byId[id]);
    }

    if (selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE) {
      if (physicians.data) {
        physicianOptions = [noneOptionItem].concat(
          filterIsPhysicianPermission(
            physicians.data.sortedByLastName.map(
              id => physicians.data.byId[id],
            ),
          ).map(p => ({
            id: p.id,
            label: getName(p.firstName, p.lastName, ''),
          })),
        );
      }
    } else if (ekgStacks.data) {
      const selectedInboxRecordIds = ekgStacks.data.stacks[selectedInboxId];
      if (
        selectedInboxRecordIds &&
        selectedInboxRecordIds.sortedByTimestamp &&
        selectedInboxRecordIds.sortedByTimestamp.length > 0
      ) {
        const selectedInboxRecords = selectedInboxRecordIds.sortedByTimestamp.map(
          id => ekgs.data.byId[id],
        );
        physicianOptions = [noneOptionItem].concat(
          this.filterPhysicianFromRecordings(selectedInboxRecords),
        );
      }
    }

    if (ekgStacks.data) {
      const selectedInboxRecordIds =
        ekgStacks.data.stacks[EKG_REVIEW_PAGE_TABS.TRIAGE];
      if (selectedInboxRecordIds && selectedInboxRecordIds.sortedByTimestamp) {
        triageCount = selectedInboxRecordIds.sortedByTimestamp.length;
      }
    }

    if (ekgStackCounts.data && me.data) {
      currentLoggedInPhysicianId = me.data.profile.id;
      physicianCount =
        ekgStackCounts.data.physicians.byId[currentLoggedInPhysicianId];
      // confirmedCount = ekgStackCounts.data.confirmed
    }

    const hasNoMoreTriageRecords =
      stackNextResultsToken && stackNextResultsToken.token === null;
    if (!checkServiceProviderFeatureEnabled(me)) {
      return (
        <div data-page="ekg-review" className={styles.ekgReview}>
          <AccessDeniedContent title="ECG Review" />
        </div>
      );
    }

    return (
      <div
        data-page="ekg-review"
        data-value={dataIsFetching ? null : recordings.length}
        className={styles.ekgReview}
      >
        <ContentHeader
          isLoading={dataIsFetching}
          showAddPatient={false}
          showLastRefresh={!me.isFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={handleOnRefreshClick}
          hasTabs
          text="ECG Review"
          me={me}
        />

        {me.isFetching ? (
          <div className={styles.contentWrapper}>
            <EcgLoader />
          </div>
        ) : (
          <React.Fragment>
            <PageTabs>
              <PageTab
                dataAction="Open-Review"
                isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE}
                handleOnClick={() =>
                  handleOnTabClick(EKG_REVIEW_PAGE_TABS.TRIAGE)
                }
                getLabel={
                  triageCount !== undefined
                    ? () => (
                        <React.Fragment>
                          Open for Review
                          <div className={styles.badgeCount}>{triageCount}</div>
                        </React.Fragment>
                      )
                    : () => 'Open for Review'
                }
              />
              <PageTab
                dataAction="Personal-Inbox"
                isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.PHYSICIAN}
                handleOnClick={() =>
                  handleOnTabClick(EKG_REVIEW_PAGE_TABS.PHYSICIAN)
                }
                getLabel={
                  physicianCount !== undefined
                    ? () => <React.Fragment>Personal Inbox</React.Fragment>
                    : () => 'Personal Inbox'
                }
              />

              <PageTab
                dataAction="Practices-Inbox"
                isActive={
                  selectedPageTab === EKG_REVIEW_PAGE_TABS.KPSP_PRACTICE_INBOX
                }
                handleOnClick={() =>
                  handleOnTabClick(EKG_REVIEW_PAGE_TABS.KPSP_PRACTICE_INBOX)
                }
                getLabel={
                  triageCount !== undefined
                    ? () => <React.Fragment>Practices Inbox</React.Fragment>
                    : () => 'Practices Inbox'
                }
              />
              <PageTab
                isActive={selectedPageTab === EKG_REVIEW_PAGE_TABS.CONFIRMED}
                handleOnClick={() =>
                  handleOnTabClick(EKG_REVIEW_PAGE_TABS.CONFIRMED)
                }
                label="Completed"
              />
            </PageTabs>

            {selectedPageTab === EKG_REVIEW_PAGE_TABS.PHYSICIAN && (
              <div
                className={styles.filters}
                data-page={`ecg-reivew-tab-${selectedPageTab}`}
                data-action="select-physician"
              >
                <SelectDropdown
                  isLoading={
                    physicians.isFetching ||
                    ekgs.isFetching ||
                    ekgStacks.isFetching
                  }
                  isClearable={false}
                  backspaceRemovesValue={false}
                  value={selectedInbox}
                  onMenuOpen={this.handleOnInboxClick}
                  onChange={handleOnPhysicianInboxChange}
                  options={inboxOptions}
                  placeholder="Provider..."
                  noOptionsMessage="No provider found"
                  getOptionLabel={p => {
                    const optionLabel = getName(p.firstName, p.lastName, '');
                    return optionLabel;
                  }}
                  getOptionValue={d => d.id}
                />
              </div>
            )}
            {/* Dropdown for Practices inbox */}
            {selectedPageTab === EKG_REVIEW_PAGE_TABS.KPSP_PRACTICE_INBOX && (
              <div
                className={styles.filters}
                data-page={`ecg-reivew-tab-${selectedPageTab}`}
                data-action="select-ordering-provider"
              >
                <SelectDropdown
                  isLoading={
                    physicians.isFetching ||
                    ekgs.isFetching ||
                    orderingPactices.isFetching ||
                    ekgStacks.isFetching
                  }
                  isClearable={false}
                  backspaceRemovesValue={false}
                  value={selectedInbox}
                  onMenuOpen={this.handleOnInboxClick}
                  onChange={handleOnProviderInboxChange}
                  options={orderingPacticesOptions}
                  placeholder="Provider..."
                  noOptionsMessage="No provider found"
                  getOptionLabel={p => p.name}
                  getOptionValue={d => d.id}
                />
              </div>
            )}

            {selectedPageTab === EKG_REVIEW_PAGE_TABS.TRIAGE &&
              triageCount > 1000 && (
                <React.Fragment>
                  <div className={styles.resultsHeader}>
                    <SearchResultsLabel
                      totalRecords={triageCount || 0}
                      totalResults={recordings.length}
                      className={styles.resultsHeaderLabel}
                      isLoading={dataIsFetching || ekgStacks.isFetching}
                    />
                    <button
                      onClick={this.handleOnTriageEKGNextClick}
                      className={styles.nextResultsButton}
                      type="button"
                      disabled={
                        triageCount === 0 ||
                        dataIsFetching ||
                        ekgStacks.isFetching ||
                        hasNoMoreTriageRecords
                      }
                    >
                      <span>Next Set</span>
                      <NextIcon />
                    </button>
                  </div>
                  <div className={styles.resultsHeaderNote}>
                    {hasNoMoreTriageRecords &&
                    !(dataIsFetching || ekgStacks.isFetching)
                      ? 'No more records to retrieve.'
                      : 'You have more than 1000 records. Please use "Next" button to get more records.'}
                  </div>
                </React.Fragment>
              )}

            {selectedPageTab === EKG_REVIEW_PAGE_TABS.CONFIRMED && (
              <div
                className={styles.monthSelection}
                data-page={`ecg-review-tab-${selectedPageTab}`}
                data-action="select-month"
              >
                <button
                  className={styles.prevButton}
                  onClick={() => handleOnConfirmedMonthClick(-1)}
                  disabled={refreshClicked}
                >
                  <PrevIcon />
                </button>
                {/* Not ISO 8601 */}
                <p className={styles.monthText}>
                  {moment(selectedConfirmedCurrentMonth).format(
                    DATE_OMIT_DAY_FMT,
                  )}
                </p>
                <button
                  className={styles.nextButton}
                  onClick={() => handleOnConfirmedMonthClick(1)}
                  disabled={
                    moment(selectedConfirmedCurrentMonth)
                      .add(1, 'month')
                      .startOf('month')
                      .isAfter(moment(), 'day') || refreshClicked
                  }
                >
                  <NextIcon />
                </button>
              </div>
            )}

            <div
              className={styles.tableContent}
              style={{
                height: contentHeightRealestate,
                width: contentWidthRealestate,
              }}
              data-page={`ecg-review-table_${selectedPageTab}`}
              data-value={dataIsFetching ? null : recordings.length}
            >
              <EkgTable
                enableLoader={recordingIds.length === 0 || refreshClicked}
                showLoader={dataIsFetching || ekgStacks.isFetching}
                data={recordings}
                rowHeight={EKG_TABLE_ROW_HEIGHT}
                showRowSelection={true}
                selected={selectedEkgs}
                onSelectionClick={handleOnSelectionClick}
                height={contentHeightRealestate}
                width={contentWidthRealestate}
                onRowClick={this.onEkgTableRowClick}
                selectedIndex={selectedIndex}
                sortBy={sortBy}
                sortDirection={sortDirection}
                me={me}
                filterDate={
                  !moment(selectedStartDate).isSame(dateRange[0], 'day') ||
                  !moment(selectedEndDate).isSame(dateRange[1], 'day')
                }
                filterPatient={selectedPatientId}
                filterAnalysis={selectedEkgResult.length > 0}
                filterAnalysisBy={selectedPhysicianId}
                filterPhysicians={
                  selectedPhysicians && selectedPhysicians.length > 0
                }
                filterAssignedPhysicians={
                  selectedAssignedPhysicians &&
                  selectedAssignedPhysicians.length > 0
                }
                filterQtOrderingPractice={
                  selectedQtOrderingPractice &&
                  selectedQtOrderingPractice.length > 0
                }
                filterBpm={
                  selectedBpmStartValue !== MIN_BPM_VALUE ||
                  selectedBpmEndValue !== MAX_BPM_VALUE
                }
                filterQtcf={
                  selectedQtcfStartValue !== MIN_QTCF_VALUE ||
                  selectedQtcfEndValue !== MAX_QTCF_VALUE
                }
                handleOnFilterButtonClick={handleOnFilterButtonClick}
                handleOnFilterChange={handleOnFilterChange}
                handleOnSortClick={handleOnSortClick}
                handleOnOutsidePopoverClick={() =>
                  handleOnFilterButtonClick(null)
                }
                handleOnBulkAction={handleOnBulkAction}
                handleOnBulkActionTriggerModal={handleOnBulkActionTriggerModal}
                handleOnBulkActionCloseModal={handleOnBulkActionCloseModal}
                handleOnBulkActionClearSelection={() =>
                  handleOnSelectionClick({})
                }
                bulkActionComplete={bulkActionComplete}
                bulkActionIsFetching={bulkActionIsFetching}
                bulkActionSuccessMessage={bulkActionSuccessMessage}
                showBulkActionRemove={false}
                selectedPopover={selectedPopover}
                showConfirmedDate={selectedInboxId === CONFIRMED}
                selectedInboxId={selectedInboxId}
                confirmedMonthDate={moment(selectedConfirmedCurrentMonth)}
                selectedStartDate={selectedStartDate}
                selectedEndDate={selectedEndDate}
                dateRange={dateRange}
                selectedBpmStartValue={selectedBpmStartValue}
                selectedBpmEndValue={selectedBpmEndValue}
                bpmRange={[MIN_BPM_VALUE, MAX_BPM_VALUE]}
                selectedQtcfStartValue={selectedQtcfStartValue}
                selectedQtcfEndValue={selectedQtcfEndValue}
                qtcfRange={[MIN_QTCF_VALUE, MAX_QTCF_VALUE]}
                selectedIntrText={selectedIntrText}
                selectedPatientText={selectedPatientText}
                showPatientColumns
                patients={patients}
                selectedPatientId={selectedPatientId}
                physicians={physicians}
                selectedPhysicianId={selectedPhysicianId}
                physicianOptions={physicianOptions}
                selectedPhysicians={selectedPhysicians}
                selectedAssignedPhysicians={selectedAssignedPhysicians}
                orderingPacticesOptions={orderingPacticesOptions}
                selectedQtOrderingPractice={selectedQtOrderingPractice}
                ekgResults={getEkgResultOptions().slice(1)}
                selectedEkgResult={selectedEkgResult}
                showOrderingProvider={false}
                serviceProviderTable={true}
                selectedPageTab={selectedPageTab}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default QtEkgReview;



// WEBPACK FOOTER //
// ./src/legacy/pages/QtEkgReview/QtEkgReview.jsx